import React from 'react';
import type { HeadFC, HeadProps, PageProps } from 'gatsby';
import { graphql, Script } from 'gatsby';

import { DEFAULT_PAGE_DESCRIPTION } from '../../../../md-config';
import { GLOBAL_CSS, GLOBAL_CSS_FONTS } from '../../../../md-css-config';
import { BasicPageFooter } from '../../../components/page/BasicPageFooter/BasicPageFooter';
import { createBreadcrumb } from '../../../utils/breadcrumbsUtil';
import { DefaultHead } from '../../../utils/headUtil';

export const query = graphql`
  query StyleGuidePage {
    site {
      ...SiteFragment
    }
  }
`;

export const Head: HeadFC<Queries.StyleGuidePageQuery> = ({
  location: { pathname },
}: HeadProps<Queries.StyleGuidePageQuery>) => {
  const breadcrumbs = createBreadcrumb('Performance test', pathname);
  return (
    <DefaultHead
      pagePath={pathname}
      pageTitle="Performance test"
      pageDescription={DEFAULT_PAGE_DESCRIPTION}
      pageBreadcrumbs={breadcrumbs}
      noIndex
    />
  );
};

const StyleGuidePage: React.FC<PageProps<Queries.StyleGuidePageQuery>> = () => {
  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: GLOBAL_CSS }} />
      <div style={{ marginTop: 85 }}>
        <div>
          This page is used for performance tests of a bare basic page without
          any contents.
        </div>
      </div>
      <BasicPageFooter />
      {/* <Script src='https://static.mindoktor.se/cookie-consent-manager/dist/cookie-consent-manager.js' /> */}
      {/* <Script src='https://static.mindoktor.se/web-analytics/dist/web-analytics.js' /> */}
      <Script src="https://static.mindoktor.se/growth-analytics/dist/growth-analytics.js" />
      <style dangerouslySetInnerHTML={{ __html: GLOBAL_CSS_FONTS }} />
    </>
  );
};

export default StyleGuidePage;
